import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as NoDataIcon } from "../../assets/images/icon-noData.svg";
import Styles from "../../scss/orderHistory.module.scss";

interface INoSearchResultProps {
  title?: string;
  info?: string;
}

export default function NoSearchResult({
  title,
  info
}: INoSearchResultProps) {
  const { t } = useTranslation();
  return (
    <div className={Styles.noOdersContainer}>
      <NoDataIcon />
      <p className={Styles.noOrderTxt}>{title ? t(title) : t("order.emptyList.default")}</p>
      <p className={Styles.searchAgainTxt}>{info ? t(info) : t("order.emptyList.default")}</p>
    </div>
  )
}
